import { useContext } from 'react';
import { EMPTY_OBJECT, AppContext, UserContext } from 'commons-ui';

import useService from '../utils/useService';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT, setConfirmationDialog } = params;
	const { app, showAlert } = useContext(AppContext);
	const { user } = useContext(UserContext);
	const { toggleIsDisabledField } = useService();
	switch (action.id) {
		case 'edit':
			return () => {
				history.push({
					pathname: '/dashboard/finance/ctd/ctdOffers/edit',
					state: {
						rowData
					}
				});
			};
		case 'clone':
			return () => {
				const filteredRowData = { segmentList: action.segmentList, mapValues: action.mapValues };
				history.push({
					pathname: '/dashboard/finance/ctd/ctdOffers/clone',
					state: {
						rowData,
						...filteredRowData
					}
				});
			};
		case 'offers':
			return () => {
				history.push({
					pathname: '/dashboard/finance/ctd/ctdOffers/conversionDetails',
					state: {
						rowData
					}
				});
			};
		case 'add':
			return () => {
				const filteredRowData = { segmentList: action.segmentList, mapValues: action.mapValues };
				history.push({
					pathname: '/dashboard/finance/ctd/ctdOffers/create',
					state: filteredRowData
				});
			};
		case 'back':
			return () => {
				history.push({
					pathname: '/dashboard/finance/ctd/ctdOffers/list'
				});
			};
		case 'remove': {
			const toggleIsDisabled = () => {
				return toggleIsDisabledField(rowData, history, user, app, showAlert);
			};
			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Remove from app?',
					handleAlertConfirmation: toggleIsDisabled
				});
			};
		}
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
